import {APPLICATION_NAME_HAIDI} from '@wallaby-ui/haidi/src/js/common/constants';
import {default as AppConfigHaidi} from '@wallaby-ui/haidi/src/js/config/app_config';
import {default as AppConfigMerie} from '@wallaby-ui/merie/src/js/config/app_config';

const applicationName =
  process.env.STORYBOOK_APPLICATION_NAME ?? APPLICATION_NAME_HAIDI;

export const AppConfig =
  applicationName === APPLICATION_NAME_HAIDI ? AppConfigHaidi : AppConfigMerie;
